import { useState } from "react";
import Markdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import { IoMdArrowDropdownCircle, IoMdArrowDropupCircle  } from "react-icons/io";
import moment from "moment";
import 'moment/locale/es';

import ExpandablePanel from '../../components/ExpandablePanel';
import { deadlineStatusEnum, isProjectCancelled, isProjectFinished, projectStatusEnum, toolbarActions } from '../../services/EnumsService';
import ExpandableTaskComponent from '../Task/ExpandableTaskComponent';
import ToolbarComponent from '../toolbar/ToolbarComponent';
import ToolbarOptionComponent from '../toolbar/ToolbarOptionComponent';
import { TaskModal } from '../Task/TaskModal';
import { ProjectModal } from "./ProjectModal";
import ProjectResourceComponent from "./ProjectResourceComponent";
import ProjectResourceModal from "./ProjectResourceModal";
import { projectOrderUp, projectOrderDown,projectStart,projectPause, projectFinish,projectCancel } from "../../api/project.api";
import { taskOrder } from "../../api/tasks.api";
import { CategoryData } from "../../pages/Category/CategoryWrapper";
import { showError } from "../../services/toastServices";
import { BulkTaskModal } from "../Task/BulkTaskModal";

export default function ExpandableProjectComponent({project, isFirst, isLast, expanded, onToggle, expandedTaskId: initialExpandedTaskId}) {
    const [showProjectModal, setShowProjectModal] = useState(false)
    const [showTaskModal, setShowTaskModal] = useState(false)
    const [showBulkTaskModal, setShowBulkTaskModal] = useState(false)
    const [showProjectResourceModal, setShowProjectResourceModal] = useState(false)
    const [expandedTaskId, setExpandedTaskId] = useState(initialExpandedTaskId)
    const [dragTaskId, setDragTaskId] = useState(null)
    const [dragOverTaskId, setDragOverTaskId] = useState(null)
    const [isTaskDragging, setIsTaskDragging] = useState(false)
    const [isTaskDragOverProject, setIsTaskDragOverProject] = useState(false)
    
    // Usar CategoryData solo si está disponible
    const categoryContext = CategoryData();
    const category = categoryContext?.category;
    const refreshProjectsCategory = categoryContext?.refreshProjectsCategory || (() => {});

    // Actualizar expandedTaskId cuando cambie initialExpandedTaskId
    useState(() => {
        if (initialExpandedTaskId) {
            setExpandedTaskId(initialExpandedTaskId);
        }
    }, [initialExpandedTaskId]);

    const addTaskAction = (()=>{
        setShowTaskModal(true)
    })
    const addTaskCloseAction = (()=>{
        setShowTaskModal(false)
    })

    const bulkAddTaskAction = (()=>{
        setShowBulkTaskModal(true)
    })
    const bulkAddTaskCloseAction = (()=>{
        setShowBulkTaskModal(false)
    })

    const createProjectResourceAction = (()=>{
        setShowProjectResourceModal(true)
    })
    const createProjectResourceCloseAction = (()=>{
        setShowProjectResourceModal(false)
    })
    const editProjectAction = (()=>{
        setShowProjectModal(true)
    })
    const editProjectCloseAction = (()=>{
        setShowProjectModal(false)
    })

    const editProjectModal = (<ProjectModal projectId={project.id} closeAction={editProjectCloseAction}></ProjectModal>)
    const addTaskModal = (<TaskModal project={project} closeAction={addTaskCloseAction}></TaskModal>)
    const bulkAddTaskModal = (<BulkTaskModal project={project} closeAction={bulkAddTaskCloseAction}></BulkTaskModal>)
    const addProjectResourceModal = (<ProjectResourceModal project={project} closeAction={createProjectResourceCloseAction}></ProjectResourceModal>)

    const startProjectAction =(async ()=>{
        await projectStart(project.id, changeStatusError)
        refreshProjectsCategory();
    })

    const pauseProjectAction =(async ()=>{
        await projectPause(project.id, changeStatusError)
        refreshProjectsCategory();
    })
    const finishProjectAction =(async ()=>{
        await projectFinish(project.id, changeStatusError)
        refreshProjectsCategory();
    })

    const cancelProjectAction =(async ()=>{
        await projectCancel(project.id, changeStatusError)
        refreshProjectsCategory();
    })

    const changeStatusError = ((error)=>{
        showError(`Error al cambiar el estado del proyecto. ${error.message}`)

    })

    const renderDeadline = (()=>{
        if(isProjectFinished(project) || isProjectCancelled(project)) return
        moment.locale('es')
        const text = `(deadline ${moment(project.deadline).endOf('day').fromNow()})`
        
        return(
            <div className="font-bold text-l text-right ml-2 " 
            style={{ color: `${deadlineStatusEnum(project.deadlineStatus).color}`}} >{moment(project.deadline).endOf('day').fromNow()}</div>
        )
    })

    const toolbarIcons = (
            <ToolbarComponent className=''>
                <ToolbarOptionComponent title={'Editar'} size={25} icon={toolbarActions.Edit} clickAction={editProjectAction}/>
                <ToolbarOptionComponent title={'Iniciar'} size={25} icon={toolbarActions.Start} clickAction={startProjectAction}/>
                <ToolbarOptionComponent title={'Pausar'} size={25} icon={toolbarActions.Pause} clickAction={pauseProjectAction}/>
                <ToolbarOptionComponent title={'Finalizar'} size={25} icon={toolbarActions.Finish} clickAction={finishProjectAction}/>
                <ToolbarOptionComponent title={'Cancelar'} size={25} icon={toolbarActions.Cancel} clickAction={cancelProjectAction}/>
            </ToolbarComponent>

    );

    const header = (
        <div className='flex flex-col'>
            <div className='flex flex-row text-xl'>
                <div className='px-2 rounded-md flex flex-row' style={{ backgroundColor: `${projectStatusEnum(project.status).color}`}}>
                    {project.name}
                    <div className='ml-2 text-gray-400'>(#{project.tasks.length})</div>
                </div>
                
                {renderDeadline()}
            </div>
        </div>
      );


    const renderTasks = (project) => {
        if(project === undefined || project.tasks === undefined) return
        const orderedTasks = [...project.tasks].sort((a, b) => a.order - b.order)

        const handleTaskDrop = async (toIndex, draggedTaskId) => {
            const newOrder = toIndex
            try {
                await taskOrder(draggedTaskId, newOrder,  (response) => {
                    refreshProjectsCategory()
                }, (error) => {
                    showError(`Error al reordenar la tarea. ${error.message}`)
                }
            )
                refreshProjectsCategory()
            } catch (error) {
                showError('Error en handleTaskDrop:', error);
            }
        }

        return orderedTasks.map((task, index) => (
            <div
                key={task.id}
                draggable
                onDragStart={() => {
                    setDragTaskId(task.id)
                    setIsTaskDragging(true)
                }}
                onDragOver={(e) => {
                    e.preventDefault()
                    if (dragTaskId && dragTaskId !== task.id) {
                        setDragOverTaskId(task.id)
                    }
                }}
                onDragLeave={() => setDragOverTaskId(null)}
                onDragEnd={() => {
                    setDragTaskId(null)
                    setDragOverTaskId(null)
                    setIsTaskDragOverProject(false)
                    setIsTaskDragging(false)
                }}
                onDrop={async (e) => {
                    e.preventDefault()
                    if (!dragTaskId || dragTaskId === task.id) return
                    await handleTaskDrop(index, dragTaskId)
                    setDragTaskId(null)
                    setDragOverTaskId(null)
                    setIsTaskDragOverProject(false)
                    setIsTaskDragging(false)
                }}
                className={`mb-2 ${dragOverTaskId === task.id ? 'ring-1 ring-blue-300 rounded-md' : ''}`}
            >
                <ExpandableTaskComponent
                    task={task}
                    expanded={expandedTaskId === task.id}
                    onToggle={(nextExpanded) => setExpandedTaskId(nextExpanded ? task.id : null)}
                />
            </div>
        ))
    }
        
    const renderResources = (project) => {
        if(project === undefined || project.tasks === undefined) return
        return project.resources.map((resource) => (
            <ProjectResourceComponent key={resource.id} projectResource={resource} />
        ))
    }


    return (
        <div className=''>
            {showProjectModal && editProjectModal}
            {showTaskModal && addTaskModal}
            {showBulkTaskModal && bulkAddTaskModal}
            {showProjectResourceModal && addProjectResourceModal}

            <ExpandablePanel key={project.id} header={header} toolbarIcons={toolbarIcons} expanded={expanded} onToggle={onToggle}>

                <Markdown 
                    className='border-l-4 bg-slate-100 pl-2 pr-2 prose max-w-full max-h-60 overflow-y-scroll mb-2'
                    remarkPlugins={[remarkGfm]}
                    >
                        {project.richDescription}
                </Markdown>

                <div className="mb-3 p-3 rounded-md border border-gray-200 bg-gray-50">
                    <div className="flex flex-row items-center mb-2">
                        <div className='font-bold text-lg'>Recursos</div>
                        <div className='mt-0.5'>
                            <ToolbarComponent className='ml-2'>
                                <ToolbarOptionComponent title={'+ Recurso'} size={20} icon={toolbarActions.AddResource} clickAction={createProjectResourceAction}/>
                            </ToolbarComponent>
                        </div>
                    </div>
                    {renderResources(project)}
                </div>

                <div className='p-3 rounded-md border border-gray-200 bg-white'>
                    <div className="flex flex-row items-center mb-2">
                        <div className="font-bold text-lg">Tareas</div>
                        <div className="pt-0.5">
                            <ToolbarComponent className='ml-2'>
                                <ToolbarOptionComponent title={'+ Task'} size={20} icon={toolbarActions.AddTask} clickAction={addTaskAction}/>
                                <ToolbarOptionComponent title={'+ Lista de tareas'} size={20} icon={toolbarActions.AddBulkTask} clickAction={bulkAddTaskAction}/>
                            </ToolbarComponent>
                        </div>
                    </div>
                    <div 
                        className={`rounded ${isTaskDragOverProject && isTaskDragging ? 'ring-1 ring-blue-200 bg-blue-50/50' : ''}`}
                        onDragOver={(e) => {
                            if (dragTaskId) {
                                e.preventDefault()
                                setIsTaskDragOverProject(true)
                            }
                        }}
                        onDragLeave={() => setIsTaskDragOverProject(false)}
                    >
                        {renderTasks(project)}
                    </div>
                </div>

            </ExpandablePanel>
        </div>
    )
}